import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "shudeles-details" }
const _hoisted_2 = { class: "mt-2 wrapper-details shudeles-details" }
const _hoisted_3 = { class: "d-flex direction-column" }
const _hoisted_4 = { class: "d-flex a-i-center j-content-s-be" }
const _hoisted_5 = { class: "uppercase text-raleway-13" }
const _hoisted_6 = { class: "uppercase text-motserrat-8-bold text-end" }
const _hoisted_7 = { class: "d-flex schedules-wrapper w-100 j-content-s-be shudeles-data" }
const _hoisted_8 = { class: "d-flex a-i-center" }
const _hoisted_9 = { class: "d-flex a-i-center" }
const _hoisted_10 = { class: "d-flex a-i-center" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", { class: "text-raleway-20" }, " : ", -1)
const _hoisted_12 = { class: "d-flex j-content-start a-i-center mt-4" }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { key: 1 }
const _hoisted_15 = ["onClick"]

import CheckBoxComponent from "../../../components/select/CheckBoxComponent.vue";
import SelectTimePicker from "@/components/select/SelectTimePicker.vue";
import { computed, onBeforeMount, ref, watch } from "vue";
import { ChedulesDetails } from "@/store/modules/accountDetails/type";
import { ResetFormType } from "@/store/modules/newOrders/type";
import { Locations } from "@/store/modules/Locations/type";
import { Schedules } from "@/store/modules/Schedules/type";
import { Costumers } from "@/store/modules/Customers/type";
import { IStore } from "@/store/types/StoreType";
import { useStore } from "vuex";


export default /*#__PURE__*/_defineComponent({
  __name: 'shedulesComponent',
  props: {
    values: {},
    resetForm: { type: Function },
    initialValues: {},
    errors: {},
    onSubmit: { type: Function }
  },
  setup(__props: any) {

const props = __props;



const _errors =
  ref<Partial<Record<keyof ChedulesDetails, string | undefined>>>();
const _values = ref<ChedulesDetails>(props.values);

const store = useStore<IStore>();
const days = ref([
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
  "Sunday",
]);
// locations
const locations = ref(
  computed<Locations[]>(() => store.getters?.getStockLocations)
);
// chedules
const shedules = ref(
  computed<Schedules>(() => store.getters.getSchedulesInSelectedLocation)
);

const selectedId = ref(
  computed(() => store.getters?.getSelectedSchedulesInLocation)
);
const saveSelected = ref(computed(() => store.getters.getSaveSelectAddress));

const customerDataUser = ref(
  computed<Costumers[]>(() => store?.getters?.getUserCustomerData)
);
const locationSelected = ref(
  computed<Locations[]>(() => store.getters.getStockLocationsInSelectedAddress)
);

const selectAddress = (id: number | null) => {
  props.resetForm();
  store.commit("updateSelectedSchedulesInLocation", { id });
  store.commit("updateAccountSchedulesLocation", locationSelected.value[0]);
};

watch(
  () => props.values,
  (newValue) => {
    _values.value = newValue;
  },
  {
    deep: true,
  }
);

watch(
  () => props.errors,
  (newValueErrors) => {
    _errors.value = newValueErrors;
  },
  {
    deep: true,
  }
);

const deleteAddress = async () => {
  if (locations.value.length > 0 && selectedId.value) {
    ///chedules
    await store.dispatch("deleteSelectSchedule", shedules.value.id);
    /// stockOperation
    await store.dispatch("deleteSelectStock");
    /// locations
    await store.dispatch("deleteSelectLocation", saveSelected.value);
    /// accountDetails
    store.commit("updateAccountSchedulesDrop");

    if (locations.value.length > 0)
      selectAddress(locations?.value[locations?.value?.length - 1]?.id);
  }
  props?.resetForm();
};

onBeforeMount(async () => {
  await store.dispatch("getSchedules");
  await store.dispatch("getSchedulesCostumers");
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("article", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.$tc("shedule")), 1),
          _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.$tc("(optional)")), 1)
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(days.value, (day, i) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "d-flex a-i-center j-content-s-be shedules w-100n",
            key: i
          }, [
            _createElementVNode("div", _hoisted_7, [
              _createVNode(CheckBoxComponent, {
                shedules: 
                (shedules.value?.details || [])?.find(
                  (element) => element?.day === i + 1
                ) || []
              ,
                day: _ctx.$tc(day),
                i: i,
                values: _ctx.initialValues
              }, null, 8, ["shedules", "day", "i", "values"]),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("div", null, [
                    _createVNode(SelectTimePicker, {
                      tabindex: 21 + i,
                      name: 'day_start' + i,
                      date: 
                      (shedules.value?.details || [])?.length > 0
                        ? (shedules.value?.details || [])?.find(
                            (element) => element?.day === i + 1
                          )?.work_time || '--.--'
                        : '--.--'
                    ,
                      disable: _ctx.values['check_day_' + (i + 1) as keyof ChedulesDetails],
                      autofocus: true
                    }, null, 8, ["tabindex", "name", "date", "disable"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _hoisted_11,
                  _createElementVNode("div", null, [
                    _createVNode(SelectTimePicker, {
                      tabindex: 21 + i,
                      name: 'day_end' + i,
                      date: 
                      (shedules.value?.details || [])?.length > 0
                        ? (shedules.value?.details || [])?.find(
                            (element) => element?.day === i + 1
                          )?.work_end || '--.--'
                        : '--.--'
                    ,
                      disable: _ctx.values['check_day_' + (i + 1) as keyof ChedulesDetails],
                      autofocus: false
                    }, null, 8, ["tabindex", "name", "date", "disable"])
                  ])
                ])
              ])
            ])
          ]))
        }), 128)),
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("button", {
            id: "save_or_delete_address",
            class: "btn btn-default-inactive-sm mr-2 text-raleway-14 shedules-btn",
            onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (props?.onSubmit && props?.onSubmit(...args)), ["stop"]))
          }, [
            (locations.value.length > 0 && saveSelected.value === selectedId.value)
              ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(_ctx.$t("Save address")), 1))
              : (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(_ctx.$t("Add address")), 1))
          ]),
          _withDirectives(_createElementVNode("div", {
            id: "delete_address",
            class: "btn btn-default-inactive-sm text-raleway-14 shedules-btn",
            onClick: _withModifiers(deleteAddress, ["stop"])
          }, [
            _createElementVNode("span", null, _toDisplayString(_ctx.$t("Delete")), 1)
          ], 8, _hoisted_15), [
            [_vShow, 
              saveSelected.value &&
              selectedId.value &&
              saveSelected.value === selectedId.value &&
              locations.value.length > 0
            ]
          ])
        ])
      ])
    ])
  ]))
}
}

})